export default __webpack_public_path__ + "static/media/hamburger.572e08b0.svg";